import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { append, contains, keys } from 'ramda';
import classnames from 'classnames';
import { get } from 'object-path';

import { X } from 'react-feather';
import UserDropdown from '../UserDropdown/UserDropdownContainer';
import UpdoxPill from '../UpdoxPill/UpdoxPill';


class UserMultiSelect extends Component {

  static propTypes = {
    autoFocus: PropTypes.bool,              // automatically focuses the input
    id: PropTypes.string,                   // id for the input element for the surrounding label for wcag
    qaId: PropTypes.string,                 // the data qa name for the element
    excludeSelfUser: PropTypes.bool,        // if true then the identity user will be excluded
    identityId: PropTypes.number,           // the user ID of the identity user
    inputPlaceholderText: PropTypes.string, // placeholder text for multi-select input box
    noResultsText: PropTypes.string,        // text to display when no users match input text
    onChange: PropTypes.func.isRequired,    // function callback when a user is selected or removed
    onClearAll: PropTypes.func,             // if a callback function is provided then the button will be present when one or more users has been selected
    users: PropTypes.object,                // object of userId -> user
    usersToExclude: PropTypes.array,        // array of userIds to exclude
    value: PropTypes.array.isRequired,      // array of userIds
  };

  constructor(props) {
    super(props);
    this.inputElement = React.createRef();
    this.state = {
      input: '',
      showDropdown: false,
    }
  }

  isUserExcluded = userId =>
    (this.props.excludeSelfUser && this.props.identityId === userId) ||
    (this.props.usersToExclude && contains(userId, this.props.usersToExclude));

  isUserSelected = userId => this.props.value && contains(userId, this.props.value);

  getFilteredUserIds = () => keys(this.props.users)
    .map(userId => parseInt(userId, 10))
    .filter(userId => this.isUserExcluded(userId) || this.isUserSelected(userId));

  handleClick = () => this.inputElement.current.focus();

  handleRemove = (event, userId) => {
    event.preventDefault();
    event.stopPropagation();
    this.props.onChange && this.props.onChange(this.props.value.filter(v => v !== userId));
  };

  handleSelect = (userId, event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ input: '' });
    this.props.onChange && this.props.onChange(append(userId, this.props.value));
  };

  hideDropdown = () => this.setState({ input: '', showDropdown: false });

  showDropdown = () => this.setState({ showDropdown: true });

  onTextChange = event => this.setState({ input: event.target.value, showDropdown: true });

  displayName = userId => `${get(this.props.users[userId], "firstName")} ${get(this.props.users[userId], "lastName")}`;

  render() {
    const { autoFocus, qaId, inputPlaceholderText, noResultsText, onClearAll, value, id } = this.props;
    const { input, showDropdown } = this.state;
    const usersToExclude = this.getFilteredUserIds();

    return (
      <div
        className={classnames({
          "user-multi-select": true,
          "with-dropdown": showDropdown,
        })}
        onClick={this.handleClick}
      >
        <div className="inner">
          {value.map(userId =>
            <UpdoxPill
              qaId="selectedUser"
              className="selected-pill"
              key={userId}
              content={this.displayName(userId)}
              onRemove={(event) => this.handleRemove(event, userId)}
            />
          )}
          <input
            ref={this.inputElement}
            type="text"
            className="input"
            data-qa={qaId ? `${qaId}_input` : ''}
            onChange={this.onTextChange}
            onBlur={this.hideDropdown}
            onFocus={this.showDropdown}
            value={input}
            autoFocus={autoFocus}
            placeholder={inputPlaceholderText}
            id={id}
          />
          {onClearAll && value.length > 0 &&
          <span className="clear-all" onClick={e => onClearAll(e)}>
            <X className="clear-all-icon" size={20}/>
          </span>
          }
        </div>
        <UserDropdown
          className="user-dropdown"
          qaId={qaId ? `${qaId}_userDropdown` : ''}
          ignoreTab
          onHide={this.hideDropdown}
          onSelect={this.handleSelect}
          noResultsText={noResultsText}
          text={input}
          show={showDropdown}
          usersToExclude={usersToExclude}
        />
      </div>
    )
  }

}

export default UserMultiSelect;
